var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#ECEEF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 32.81C21.31 32.81 20.66 32.46 20.2 31.85L18.7 29.85C18.67 29.81 18.55 29.76 18.5 29.75H18C13.83 29.75 11.25 28.62 11.25 23V18C11.25 13.58 13.58 11.25 18 11.25H26C30.42 11.25 32.75 13.58 32.75 18V23C32.75 27.42 30.42 29.75 26 29.75H25.5C25.42 29.75 25.35 29.79 25.3 29.85L23.8 31.85C23.34 32.46 22.69 32.81 22 32.81ZM18 12.75C14.42 12.75 12.75 14.42 12.75 18V23C12.75 27.52 14.3 28.25 18 28.25H18.5C19.01 28.25 19.59 28.54 19.9 28.95L21.4 30.95C21.75 31.41 22.25 31.41 22.6 30.95L24.1 28.95C24.43 28.51 24.95 28.25 25.5 28.25H26C29.58 28.25 31.25 26.58 31.25 23V18C31.25 14.42 29.58 12.75 26 12.75H18Z",
    fill: "#333B47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 22C21.44 22 21 21.55 21 21C21 20.45 21.45 20 22 20C22.55 20 23 20.45 23 21C23 21.55 22.56 22 22 22Z",
    fill: "#333B47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 22C25.44 22 25 21.55 25 21C25 20.45 25.45 20 26 20C26.55 20 27 20.45 27 21C27 21.55 26.56 22 26 22Z",
    fill: "#333B47"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22C17.44 22 17 21.55 17 21C17 20.45 17.45 20 18 20C18.55 20 19 20.45 19 21C19 21.55 18.56 22 18 22Z",
    fill: "#333B47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.c975e82d6452a8c560441f30c6a83023.svg";
export { ForwardRef as ReactComponent };